import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable, of, ReplaySubject } from 'rxjs';
import { share, switchMap } from 'rxjs/operators';
import { ConfigService } from 'src/app/core/services/config.service';
import { DictionaryDataItem } from '../model/DictionaryDataItem';


@Injectable({
  providedIn: 'root'
})
export class CityDictionaryService {


  localizationCode: string;

  constructor(private http: HttpClient,
              private configService: ConfigService
  ) { }

  public getCities(pattern:string ): Observable<DictionaryDataItem[]> {

    pattern = this.escapeNotAllowedChars(pattern);
    if(!pattern){
      return of<DictionaryDataItem[]>([]);
    }

      return this.http.get<DictionaryDataItem[]>(
        this.configService.PortalWebApiUrl + 'cityDictionary/city/' + pattern)
        .pipe(
          switchMap( r => {  return of<DictionaryDataItem[]>(r); } ),
          share({ connector: () => new ReplaySubject(1)}),
        );
  }

  escapeNotAllowedChars(pattern: string): string {
    if(!pattern)
      return '';
      pattern = pattern.split('/').join('%2F');
     return pattern;
  }

  public addCity(data: DictionaryDataItem): Observable<number> {
    return this.http.post<number>(
      this.configService.PortalWebApiUrl + 'cityDictionary', data);
  }
}